import { StateManager, SessionDataStore, StatePersistor } from '@idp/state-manager';
import { ICCEventBusManager } from '@idp/event-bus';
import * as localforage from 'localforage';
import { appShellInitialState } from '../models/app-shell.model';
var StateProvider = /** @class */ (function () {
    function StateProvider() {
    }
    StateProvider.setupStateManager = function () {
        if (StateProvider.stateManagerInstance) {
            return;
        }
        var statePersistor = new StatePersistor(localforage);
        StateProvider.statePersistorInstance = statePersistor;
        StateManager.setup(new SessionDataStore(), ICCEventBusManager.getInstance());
        StateProvider.stateManagerInstance = StateManager.buildStateProxyForNamespace('appShell', appShellInitialState);
        statePersistor.restore(StateManager.restore)
            .then(function () { return StateManager.lockRestore(); });
    };
    StateProvider.getStateManagerInstance = function () {
        if (!StateProvider.stateManagerInstance) {
            StateProvider.setupStateManager();
        }
        return StateProvider.stateManagerInstance;
    };
    StateProvider.getStatePersistorInstance = function () {
        if (!StateProvider.statePersistorInstance) {
            StateProvider.setupStateManager();
        }
        return StateProvider.statePersistorInstance;
    };
    return StateProvider;
}());
export { StateProvider };
//# sourceMappingURL=state-provider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/services/state-provider.js
// module id = 59
// module chunks = 8